import { render, staticRenderFns } from "./JoinedTable.vue?vue&type=template&id=2655cb42&scoped=true"
import script from "./JoinedTable.vue?vue&type=script&lang=js"
export * from "./JoinedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655cb42",
  null
  
)

export default component.exports